
import imageProject1 from './assets/images/symposium/project-1.jpg'
import userProject1 from './assets/images/symposium/project-1-user.jpg'
import slideProject1 from './assets/slides/project-1.pdf'
import imageProject2 from './assets/images/symposium/project-2.jpg'
import userProject2 from './assets/images/symposium/project-2-user.jpg'
import slideProject2 from './assets/slides/project-2.pdf'
import imageProject3 from './assets/images/symposium/project-3.jpg'
import userProject3 from './assets/images/symposium/project-3-user.jpg'
import slideProject3 from './assets/slides/project-3.pdf'
import imageProject4 from './assets/images/symposium/project-4.jpg'
import userProject4 from './assets/images/symposium/project-4-user.jpg'
import slideProject4 from './assets/slides/project-4.pdf'
import imageProject5 from './assets/images/symposium/project-5.jpg'
import userProject5 from './assets/images/symposium/project-5-user.jpg'
import slideProject5 from './assets/slides/project-5.pdf'
import imageProject6 from './assets/images/symposium/project-6.jpg'
import userProject6 from './assets/images/symposium/project-6-user.jpg'
import slideProject6 from './assets/slides/project-6.pdf'
import imageProject7 from './assets/images/symposium/project-7.jpg'
import userProject7 from './assets/images/symposium/project-7-user.jpg'
import slideProject7 from './assets/slides/project-7.pdf'
import imageProject8 from './assets/images/symposium/project-8.jpg'
import userProject8 from './assets/images/symposium/project-8-user.jpg'
import slideProject8 from './assets/slides/project-8.pdf'
import imageProject9 from './assets/images/symposium/project-9.jpg'
import userProject9 from './assets/images/symposium/project-9-user.jpg'
import slideProject9 from './assets/slides/project-9.pdf'
import imageProject10 from './assets/images/symposium/project-10.jpg'
import userProject10 from './assets/images/symposium/project-10-user.jpg'
import slideProject10 from './assets/slides/project-10.pdf'
import imageProject11 from './assets/images/symposium/project-11.jpg'
import userProject11 from './assets/images/symposium/project-11-user.jpg'
import slideProject11 from './assets/slides/project-11.pdf'
import imageProject12 from './assets/images/symposium/project-12.jpg'
import userProject12 from './assets/images/symposium/project-12-user.jpg'
import slideProject12 from './assets/slides/project-12.pdf'
import imageProject13 from './assets/images/symposium/project-13.jpg'
import userProject13 from './assets/images/symposium/project-13-user.jpg'
import slideProject13 from './assets/slides/project-13.pdf'
import imageProject14 from './assets/images/symposium/project-14.jpg'
import userProject14 from './assets/images/symposium/project-14-user.jpg'
import slideProject14 from './assets/slides/project-14.pdf'
import imageProject15 from './assets/images/symposium/project-15.jpg'
import userProject15 from './assets/images/symposium/project-15-user.jpg'
import slideProject15 from './assets/slides/project-15.pdf'
import imageProject16 from './assets/images/symposium/project-16.jpg'
import userProject16 from './assets/images/symposium/project-16-user.jpg'
import slideProject16 from './assets/slides/project-16.pdf'

const rows = [
    [
        {
            id: '1',
            type: 'social',
            video: 'fP-iD0jrZNU',
            title: {
                de: 'Ausgewogene Social Media-Nutzung',
                en: 'Debiasing Social Media Use'
            },
            image: imageProject1,
            users: ['Jürgen Buder', 'Guido Zurstiege', '<b>Lisa Rabl</b>'],
            userImage: userProject1,
            userTooltip: 'Lisa Rabl',
            abstract: {
                de: 'Dieses Projekt untersucht die Rolle kognitiver Schnittstellen (vor allem “Likes” und “Dislikes”) auf die verzerrte Rezeption von Informationen (z.B. in Echokammern) und auf die verzerrte Produktion von Informationen (z.B. Hassrede) in sozialen Medien.',
                en: 'The present project addresses the role of cognitive interfaces (particularly “likes” and “dislikes”) on biased reception of information (e.g. echo chambers) as well as on biased production of information (e.g. hate speech) on social media.'
            },
            url: {
                de: 'https://www.wissenschaftscampus-tuebingen.de/www/de/forschung/forschungsbereiche/projekt01/index.html',
                en: 'https://www.wissenschaftscampus-tuebingen.de/www/en/forschung/forschungsbereiche/projekt01/index.html'
            },
            slides: slideProject1,
            contact: '',
            aos: 'fade-right',
            aosDelay: 300
        },
        {
            id: '2',
            type: 'learning',
            video: 'XH00e1Tc45M',
            title: {
                de: '3D-Wissensräume',
                en: '3D Knowledge Spaces'
            },
            image: imageProject2,
            users: ['<b>Martin V. Butz</b>', 'Peter Gerjets', 'Martin Lachmair', 'Johannes Lohman', 'Dania Humaidan', 'Mahdi Sadeghi'],
            userImage: userProject2,
            userTooltip: 'Martin V. Butz',
            abstract: {
                de: 'Theoretische, modellierende und experimentelle Erwägungen und Fortschritte beim “predictive coding” von Ereignissen werden dargestellt und zusammengefasst. Multiperspektivische Hypermedia-Räume werden gezeigt und erste Ergebnisse beurteilt. Das Potenzial solcher Anwendungen wird kurz erörtert.',
                en: 'Theoretical, modeling, and experimental considerations and advances on Event-Predictive Cognition are introduced and summarized. Developed multiperspective hypermedia spaces are shown and preliminary results are evaluated. Future potential is briefly discussed.'
            },
            url: {
                de: 'https://www.wissenschaftscampus-tuebingen.de/www/de/forschung/forschungsbereiche/projekt02/index.html',
                en: 'https://www.wissenschaftscampus-tuebingen.de/www/en/forschung/forschungsbereiche/projekt02/index.html'
            },
            slides: slideProject2,
            contact: '',
            aos: 'fade-right',
            aosDelay: 0
        },
        {
            id: '3',
            type: 'medical',
            video: 'YoyvsKEwJOg',
            title: {
                de: 'Nutzung von medizinischen Onlineplattformen',
                en: 'Medical Online Platforms as Cognitive Interfaces'
            },
            image: imageProject3,
            users: ['Joachim Kimmerle', 'Martina Bientzle', 'Bernhard Hirt', '<b>Marie Eggeling</b>', 'Thomas Shiozawa-Bayer'],
            userImage: userProject3,
            userTooltip: 'Marie Eggeling',
            abstract: {
                de: 'In diesem Projekt wurde untersucht, wie Informationsvideos dazu genutzt werden können, Patienten über medizinische Themen zu informieren und somit ihr Verständnis von medizinischen Entscheidungen zu fördern. In der Präsentation lernen Sie etwas über zwei experimentelle Studien, die das Design von Unterstützungs-Werkzeugen untersucht haben.',
                en: 'The project investigated how information material like videos can be used to educate patients about medical topics, in order to improve their understanding in decision situations. In the virtual presentation you learn about two experimental studies which examined the design of such support tools.'
            },
            url: {
                de: 'https://www.wissenschaftscampus-tuebingen.de/www/de/forschung/forschungsbereiche/projekt03/index.html',
                en: 'https://www.wissenschaftscampus-tuebingen.de/www/en/forschung/forschungsbereiche/projekt03/index.html'
            },
            slides: slideProject3,
            contact: '',
            aos: 'fade-left',
            aosDelay: 0
        },
        {
            id: '4',
            type: 'social',
            video: '4lMlqo5G-GE',
            title: {
                de: 'Nutzung von Produktbewertungsportalen',
                en: 'Use of Product Evaluation Portals'
            },
            image: imageProject4,
            users: ['Mandy Hütter', 'Kai Sassenberg', 'Kevin Winter', '<b>Birka Zapf</b>'],
            userImage: userProject4,
            userTooltip: 'Birka Zapf',
            abstract: {
                de: 'Kundenrezensionen sind heutzutage eine wichtige Informationsquelle bei Kaufentscheidungen. Dieses Projekt untersuchte, ob Kunden Rezensionen auswählen, die ihre positive Einstellung unterstützen (sog. confirmation bias) und ob das Verfassen von Rezensionen von der Meinung anderer Personen (durchschnittliche Bewertungen) abhängt.',
                en: 'Costumers reviews are the main source of recommendations today. Therefore, the project investigated whether costumers select reviews in a way that confirms their positive attitude (=confirmation bias) and whether the contribution of reviews depends on the opinion of others (e.g. overall rating).'
            },
            url: {
                de: 'https://www.wissenschaftscampus-tuebingen.de/www/de/forschung/forschungsbereiche/projekt04/index.html',
                en: 'https://www.wissenschaftscampus-tuebingen.de/www/en/forschung/forschungsbereiche/projekt04/index.html'
            },
            slides: slideProject4,
            contact: '',
            aos: 'fade-left',
            aosDelay: 300
        }
    ],
    [
        {
            id: '5',
            type: 'medical,learning',
            video: 'IWUJUu8-yQY',
            title: {
                de: 'Förderung visueller Expertise in der Zahnmedizin',
                en: 'Fostering Image Reading Skills of Dentists'
            },
            image: imageProject5,
            users: ['Katharina Scheiter', 'Constanze Keutel', 'Fabian Hüttig', 'Enkelejda Kasneci', 'Juliane Richter', '<b>Thérése Eder</b>'],
            userImage: userProject5,
            userTooltip: 'Thérése Eder',
            abstract: {
                de: 'Dieses Projekt zielt darauf, Erkenntnisse über die Informationsverarbeitung von Studierenden der Zahnmedizin beim Betrachten von Röntgenaufnahmen zu gewinnen. Wir untersuchten, wie gut Studierende in der Lage sind, Befunde beim Betrachten von Röntgenaufnahmen entdecken und entwickelten neue Ansätze, um sie bei dieser Aufgabe zu unterstützen.',
                en: 'The project aims at gathering insights on dental students’ information processing during medical image reading of panoramic radiographs (OPTs). We investigated the current status of learning to read OPTs in university and developed new approaches to support dental students in reading OPTs.'
            },
            url: {
                de: 'https://www.wissenschaftscampus-tuebingen.de/www/de/forschung/forschungsbereiche/projekt05/index.html',
                en: 'https://www.wissenschaftscampus-tuebingen.de/www/en/forschung/forschungsbereiche/projekt05/index.html'
            },
            slides: slideProject5,
            contact: '',
            aos: 'fade-right',
            aosDelay: 300
        },
        {
            id: '6',
            type: 'learning,social',
            video: 'jSPUkmQJdZU',
            title: {
                de: 'Aufmerksamkeitsbeurteilung im Klassenzimmer',
                en: 'Attention Awareness in Classrooms'
            },
            image: imageProject6,
            users: ['Ulrich Trautwein', 'Peter Gerjets', 'Enkelejda Kasneci', 'Ömer Sümer', '<b>Patricia Goldberg</b>'],
            userImage: userProject6,
            userTooltip: 'Patricia Goldberg',
            abstract: {
                de: 'Die Aufmerksamkeit von Schülerinnen und Schülern ist ein zentraler Faktor beim Unterricht im Klassenzimmer. Doch nicht alle Lehrkräfte sind erfolgreich darin, die Aufmerksamkeit in der Klasse richtig einzuschätzen. Um Lehrkräfte zu unterstützen und die Lehrausbildung zu verbessern, zielen wir darauf ab, eine kognitive Schnittstelle zu entwickeln, die das Aufmerksamkeits-Level im Klassenzimmer erfasst und an die Lehrkraft kommuniziert.',
                en: 'Students\' attention is central for classroom learning but teachers differ in how successful they are in detecting students\' attention. To support teachers and to improve teacher training, we aim to develop a “cognitive interface“, to access and communicate students’ attentional state to the teacher.'
            },
            url: {
                de: 'https://www.wissenschaftscampus-tuebingen.de/www/de/forschung/forschungsbereiche/projekt06/index.html',
                en: 'https://www.wissenschaftscampus-tuebingen.de/www/en/forschung/forschungsbereiche/projekt06/index.html'
            },
            slides: slideProject6,
            contact: '',
            aos: 'fade-right',
            aosDelay: 0
        },
        {
            id: '7',
            type: 'social',
            video: 'fnCNSESgFNk',
            title: {
                de: 'Kontaktempfehlungssysteme',
                en: 'Contact Recommendation Systems'
            },
            image: imageProject7,
            users: ['Sonja Utz', 'Enkelejda Kasneci', '<b>Lea Baumann</b>'],
            userImage: userProject7,
            userTooltip: 'Lea Baumann',
            abstract: {
                de: 'Berufsbezogene soziale Netzwerke ermöglichen es, mit Expertinnen und Experten aus aller Welt zu beliebigen Themen Kontakte aufzubauen. Allerdings sind die meisten Menschen vor allem mit Personen aus ihrem bestehenden Arbeitsumfeld in solchen Netzwerken verknüpft. Das Projekt untersuchte, wie Menschen dazu motiviert werden können, durch ein Kontakt-Empfehlungssystem breiter gefächerte soziale Netzwerke aufzubauen.',
                en: 'Professional Social Network Sites (SNS) make it easy to connect with experts from all sorts of fields and from all over the world. Yet, most people are online mainly connected with others from their direct work environment. The project investigated how people can be encouraged to build more diverse networks with the help of contact recommender systems.'
            },
            url: {
                de: 'https://www.wissenschaftscampus-tuebingen.de/www/de/forschung/forschungsbereiche/projekt07/index.html',
                en: 'https://www.wissenschaftscampus-tuebingen.de/www/en/forschung/forschungsbereiche/projekt07/index.html'
            },
            slides: slideProject7,
            contact: '',
            aos: 'fade-left',
            aosDelay: 0
        },
        {
            id: '8',
            type: 'medical,social',
            video: 'hQdZ4L1rYvc',
            title: {
                de: 'Interaktiver Visitetisch',
                en: 'The Interactive Ward Round Table'
            },
            image: imageProject8,
            users: ['Yvonne Kammerer', 'Michael Bitzer', 'Peter Gerjets', 'Uwe Oestermeier', '<b>Caroline Leroy</b>'],
            userImage: userProject8,
            userTooltip: 'Caroline Leroy',
            abstract: {
                de: 'Der Visitetisch ist eine Nutzerschnittstelle für Multi-Touch-Tische, die darauf abzielt, klinisches Fachpersonal bei der Diagnostik von Patientinnen und Patienten zu unterstützen. Die Schnittstelle wurde durch psychologische Forschungsergebnisse inspiriert und führte zu einer positiven Bewertung durch 11 klinische ExpertInnen. Wir stellen vier Studien dar, in denen die Bedeutsamkeit gründlicher Testung von Schnittstellen betont wird. Demo-Video: <a href="https://youtu.be/w-KXnlbazW0" class="my-link" target="_blank">Interaktiver Visitetisch</a>',
                en: 'The Ward Round Table is a user interface (UI) for multi-touch tables aimed to support clinicians in diagnosing patients. The UI was motivated by psychological research findings resulting in a positive evaluation by N=11 clinicians. We present 4 studies stressing the importance of profound UI-testing. Demo video: <a href="https://youtu.be/w-KXnlbazW0" class="my-link" target="_blank">The Interactive Ward Round Table</a>'
            },
            url: {
                de: 'https://www.wissenschaftscampus-tuebingen.de/www/de/forschung/forschungsbereiche/projekt08/index.html',
                en: 'https://www.wissenschaftscampus-tuebingen.de/www/en/forschung/forschungsbereiche/projekt08/index.html'
            },
            slides: slideProject8,
            contact: '',
            aos: 'fade-left',
            aosDelay: 300
        }
    ],
    [
        {
            id: '9',
            type: 'learning,medical',
            video: 'LZ6mRNO_TXo',
            title: {
                de: 'Tübinger Hüftkonzept-App',
                en: 'Osteoarthritis Exercise App'
            },
            image: imageProject9,
            users: ['<b>Inga Krauß</b>', 'Kai Sassenberg', 'Gorden Sudeck', 'Jennifer Durst', 'Inka Rösel', 'Katharina Bernecker'],
            userImage: userProject9,
            userTooltip: 'Inga Krauß',
            abstract: {
                de: 'Digitale Gesundheits-Apps sind vielversprechende Tools, die Patienten mit Knie-Arthrosen dabei unterstützen können, körperliche Übungen auszuführen. Bewegungsbezogene Gesundheitskompetenz ist eine Voraussetzung, um solche Übungen effektiv und sicher auszuführen. Können Apps den Erwerb solcher Kompetenzen genauso gut unterstützen wie menschliche TrainerInnen?',
                en: 'Digital health applications (DHA) seem promising tools to enable osteoarthrosis patients to engage in physical exercises. Physical activity-related health competence (PAHCO) is a prerequisite to perform them effectively and safely. Can DHA substitute human interaction to foster PAHCO?'
            },
            url: {
                de: 'https://www.wissenschaftscampus-tuebingen.de/www/de/forschung/forschungsbereiche/projekt09/index.html',
                en: 'https://www.wissenschaftscampus-tuebingen.de/www/en/forschung/forschungsbereiche/projekt09/index.html'
            },
            slides: slideProject9,
            contact: '',
            aos: 'fade-right',
            aosDelay: 300
        },
        {
            id: '10',
            type: 'learning',
            video: 'OqvV6M3Okxk',
            title: {
                de: 'Touch und Arbeitsgedächtnisentlastung',
                en: 'Touch and Offloading'
            },
            image: imageProject10,
            users: ['Frank Papenmeier', 'Hauke S. Meyerhoff', '<b>Sandra Grinschgl</b>'],
            userImage: userProject10,
            userTooltip: 'Sandra Grinschgl (&copy; Klaus Ranger)',
            abstract: {
                de: 'Wir verwenden heutzutage oft externe Hilfen, um Denk- und Gedächtnisprozesse „auszulagern“ (z.B. indem wir Informationen auf dem Smartphone speichern, statt sie uns zu merken). In unserem Projekt untersuchten wir, wie moderne, touch-basierte Geräte das Auslagern kognitiver Prozesse unterstützen, und welche Konsequenzen solch eine Auslagerung hat.',
                en: 'These days, we often offload cognitive processes into external aids (e.g., storing information in a smartphone instead of memorizing it). In our project, we investigated how modern mobile touch devices support the offloading of cognitive processes and the consequences of such offloading behavior.'
            },
            url: {
                de: 'https://www.wissenschaftscampus-tuebingen.de/www/de/forschung/forschungsbereiche/projekt10/index.html',
                en: 'https://www.wissenschaftscampus-tuebingen.de/www/en/forschung/forschungsbereiche/projekt10/index.html'
            },
            slides: slideProject10,
            contact: '',
            aos: 'fade-right',
            aosDelay: 0
        },
        {
            id: '11',
            type: 'learning',
            video: 'XjZ1Mi7UbK8',
            title: {
                de: 'Ziffern erfassen',
                en: 'Digits Grasp Digits'
            },
            image: imageProject11,
            users: ['Korbinian Moeller', 'Caterina Gawrilow', '<b>Roberta Barrocas</b>'],
            userImage: userProject11,
            userTooltip: 'Roberta Barrocas',
            abstract: {
                de: 'Kinder aus fast allen Kulturen verwenden ihre Finger, wenn sie zählen. Doch die Frage, ob die Nutzung der Finger das Erlernen grundlegender numerischer Konzepte vorantreibt, ist noch ungeklärt. In diesem Projekt haben wir versucht, mit verschiedenen Forschungsmethoden einen Beitrag zu dieser Debatte zu leisten: durch einen Literaturüberblick, eine Längsschnittstudie und eine app-basierte Trainingsstudie.',
                en: 'Children from almost all cultures use their fingers for counting. Yet, the question of whether finger use drives learning of basic numerical concepts remains to be clarified. In this project we sought to contribute to this debate through different research methods: a literature review, a longitudinal study, and an app-based training study.'
            },
            url: {
                de: 'https://www.wissenschaftscampus-tuebingen.de/www/de/forschung/forschungsbereiche/projekt11/index.html',
                en: 'https://www.wissenschaftscampus-tuebingen.de/www/en/forschung/forschungsbereiche/projekt11/index.html'
            },
            slides: slideProject11,
            contact: '',
            aos: 'fade-left',
            aosDelay: 0
        },
        {
            id: '12',
            type: 'learning,medical',
            video: 'ZOlgrpEQ7mU',
            title: {
                de: 'Spielbasiertes numerisches Lernen',
                en: 'Game-based Number Learning'
            },
            image: imageProject12,
            users: ['Manuel Ninaus', 'Hans-Otto Karnath', 'Korbinian Moeller', 'Elise Klein', 'Kristian Kiili', '<b>Simon Greipl</b>'],
            userImage: userProject12,
            userTooltip: 'Simon Greipl',
            abstract: {
                de: 'Lernen und Spielen sind eng miteinander verknüpft. Daher können Lernspiele ansprechende Schnittstellen zwischen Individuum und einer digitalen Informationsumwelt herstellen, und damit traditionelle pädagogische Ansätze erweitern. Doch welche Vorteile bieten solche spielbasierten Schnittstellen für das Lernen?',
                en: 'Games for learning are successful in providing engaging interfaces between individuals and digital information environments to augment traditional educational settings. Seemingly because learning and playing are closely tied together. But what are the benefits of such game-based learning interfaces?'
            },
            url: {
                de: 'https://www.wissenschaftscampus-tuebingen.de/www/de/forschung/forschungsbereiche/projekt12/index.html',
                en: 'https://www.wissenschaftscampus-tuebingen.de/www/en/forschung/forschungsbereiche/projekt12/index.html'
            },
            slides: slideProject12,
            contact: '',
            aos: 'fade-left',
            aosDelay: 300
        }
    ],
    [
        {
            id: '13',
            type: 'learning,social',
            video: 'bJqwSnKgap0',
            title: {
                de: 'Citizen Science im Klassenzimmer',
                en: 'Citizen Science in the Classroom'
            },
            image: imageProject13,
            users: ['Christoph Randler', 'Katharina Scheiter', '<b>Alena Rögele</b>'],
            userImage: userProject13,
            userTooltip: 'Alena Rögele',
            abstract: {
                de: 'Die dargestellte Studie kombiniert das Lernen innerhalb und außerhalb des Klassenzimmers in einem Setting, bei dem Schülerinnen und Schüler mit der Unterstützung digitaler Medien an einem Citizen Science-Projekt partizipieren. Die Studie liefert erste Einsichten, wie sich ein solches Lehrkonzept auf wissenschaftliches Denken und den Wissenszuwachs von Schülerinnen und Schülern auswirkt.',
                en: 'The presented study combines out-of-school and in-classroom learning by participating in a Citizen Science project while using digital media. The study provides first insight into the effects of such a teaching concept on scientific reasoning and knowledge gain of students.'
            },
            url: {
                de: 'https://www.wissenschaftscampus-tuebingen.de/www/de/forschung/forschungsbereiche/projekt13/index.html',
                en: 'https://www.wissenschaftscampus-tuebingen.de/www/en/forschung/forschungsbereiche/projekt13/index.html'
            },
            slides: slideProject13,
            contact: '',
            aos: 'fade-right',
            aosDelay: 300
        },
        {
            id: '14',
            type: 'learning,social',
            video: '76pQVDA__Kk',
            title: {
                de: 'Lernen und soziale Identifikation via Touch',
                en: 'Learning and Social Identification via Touch'
            },
            image: imageProject14,
            users: ['Ann-Katrin Wesslein', 'Christina Matschke', '<b>Gabriela Orellana-Corrales</b>', 'Sarah Schäfer'],
            userImage: userProject14,
            userTooltip: 'Gabriela Orellana-Corrales',
            abstract: {
                de: 'In touch-gesteuerten Schnittstellen sind Informationen im Wortsinne sofort „greifbar“ (mit nur einem Tippen des Fingers). Außerdem werden in Schnittstellen Nutzerinnen und Nutzer oft durch Symbole dargestellt. Wir zeigen auf, dass Touch-Interaktionen keinen Einfluss darauf haben, was wir lernen und was wir mögen; und dass abstrakte, symbolische Darstellungen von einem selbst sich nicht auf die Ausrichtung der Aufmerksamkeit auswirken.',
                en: 'Digital interfaces (1) provide information “at our fingertips” and (2) often represent users symbolically. We observe (on 1) that touch-interactions don’t change what we learn and like and (on 2) that abstract, newly self-associated symbols don’t elicit attentional prioritization.'
            },
            url: {
                de: 'https://www.wissenschaftscampus-tuebingen.de/www/de/forschung/forschungsbereiche/projekt14/index.html',
                en: 'https://www.wissenschaftscampus-tuebingen.de/www/en/forschung/forschungsbereiche/projekt14/index.html'
            },
            slides: slideProject14,
            contact: '',
            aos: 'fade-right',
            aosDelay: 0
        },
        {
            id: '15',
            type: 'social',
            video: 'MQviKuTDuQo',
            title: {
                de: 'Emotion und Argument',
                en: 'Emotion and Argument in Digital Information Environments'
            },
            image: imageProject15,
            users: ['Sebastian Padó', 'Roman Klinger', 'Kai Sassenberg', '<b>Enrica Troiano</b>'],
            userImage: userProject15,
            userTooltip: 'Enrica Troiano',
            abstract: {
                de: 'Beeinflussen Emotionen die Überzeugungskraft? Wir untersuchen computationale linguistische Tools, die den emotionalen Gehalt und potenziell auch die Überzeugungskraft von Texten verändern können: wir fokussieren dabei auf maschinelle Übersetzungen, welche die Emotionen der Eingaben zu einem Teil beibehalten und ihre ursprünglichen Konnotationen abschwächen.',
                en: 'Do emotions influence persuasion? We investigate computational linguistics tools that can change the emotion, and potentially the persuasiveness, of texts: we focus on machine translation, which keeps the emotion of inputs only to a degree, flattening away their initial connotation.'
            },
            url: {
                de: 'https://www.wissenschaftscampus-tuebingen.de/www/de/forschung/forschungsbereiche/projekt15/index.html',
                en: 'https://www.wissenschaftscampus-tuebingen.de/www/en/forschung/forschungsbereiche/projekt15/index.html'
            },
            slides: slideProject15,
            contact: '',
            aos: 'fade-left',
            aosDelay: 0
        },
        {
            id: '16',
            type: 'social',
            video: 'NuJGGfFYtYc',
            title: {
                de: 'Kontextänderungen in Social Media Beiträgen',
                en: 'Context Changes in Social Media Contributions'
            },
            image: imageProject16,
            users: ['Thomas Ertl', 'Steffen Koch', 'Sonja Utz', '<b>Franziska Huth</b>'],
            userImage: userProject16,
            userTooltip: 'Franziska Huth',
            abstract: {
                de: 'Wie ändert sich der Kontext einer Information, wenn sie auf sozialen Medien geteilt und verbreitet wird? Wir untersuchen Methoden zur Entdeckung und interaktiven visuellen Analyse, mit denen man die Kontextveränderungen von digitalen Fragmenten auf Plattformen sozialer Medien nachvollziehen kann und bewerten in Nutzerstudien deren Effektivität.',
                en: 'How does the context of a piece of information change when it is shared and re-shared on social media? We develop methods for detection and interactive visual analysis of how digital fragments undergo context changes on social media platforms, and evaluate their effectiveness in user studies.'
            },
            url: {
                de: 'https://www.wissenschaftscampus-tuebingen.de/www/de/forschung/forschungsbereiche/projekt16/index.html',
                en: 'https://www.wissenschaftscampus-tuebingen.de/www/en/forschung/forschungsbereiche/projekt16/index.html'
            },
            slides: slideProject16,
            contact: '',
            aos: 'fade-left',
            aosDelay: 300
        }
    ]
]

window.generateProjects = function(lang) {
    let html = ''
    let modals = ''

    const tooltips = {
        homepage: lang === 'de' ? 'Gehe zu Projektseite' : 'Go to Project Homepage',
        download: lang === 'de' ? 'Folien als PDF herunterladen' : 'Download Slides as PDF',
        twitter: lang === 'de' ? 'Teilen per Twitter' : 'Share on Twitter',
        email: lang === 'de' ? 'Teilen per E-Mail' : 'Share by Email'
    }

    for (let row of rows) {
        let projectsHtml = ''

        for (let project of row) {
            const types = project.type.split(/,/)
            const subtitles = types.map(it => {
                let name = ''
                let icon = ''
                if (it === 'social') {
                    name = lang === 'de' ? 'Soziale Schnittstellen' : 'Social Interfaces'
                    icon = 'hashtag'
                } else if (it === 'medical') {
                    name = lang === 'de' ? 'Medizinische Schnittstellen' : 'Medical Interfaces'
                    icon = 'briefcase-medical'
                } else if (it === 'learning') {
                    name = lang === 'de' ? 'Lernschnittstellen' : 'Interfaces for Learning'
                    icon = 'book-reader'
                }

                return `<div><i class="fas fa-${icon} fa-fw"></i><span>${name}</span></div>`
            })
            projectsHtml += `
                <div class="column is-3" data-aos="${project.aos}" data-aos-delay="${project.aosDelay}">
                    <div class="card my-equal-height-card" data-type="${project.type}" data-id="${project.id}">
                        <div class="card-image">
                            <figure class="image is-4by3">
                                <img src="${project.image}" alt="${project.title[lang]}" />
                            </figure>
                        </div>
                        <div class="card-content">
                            <div class="media">
                                <div class="media-content">
                                    <h1>${project.title[lang]}</h1>
                                    <h2 class="has-text-grey">${subtitles.join('')}</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            `

            modals += `      
                <div class="modal my-project-modal" data-id="${project.id}">
                    <div class="modal-background"></div>
                    <div class="modal-content">
                        <div class="my-modal-close">
                            <span data-tippy-content="Close" data-tippy-placement="right">
                                <i class="fas fa-times fa-2x"></i>
                            </span>
                        </div>
                        <div class="card">
                            <div class="card-image">
                                <div class="plyr__video-embed">
                                    <iframe src="https://www.youtube.com/embed/${project.video}?iv_load_policy=3&amp;modestbranding=1&amp;showinfo=0&amp;rel=0" allowfullscreen></iframe>
                                </div>
                            </div>
                            <div class="card-content">
                                <div class="media">
                                    <div class="media-left" data-tippy-content="${project.userTooltip}">
                                        <figure class="image is-64x64">
                                            <img class="is-rounded" src="${project.userImage}" alt="${project.users}" />
                                        </figure>
                                    </div>
                                    <div class="media-content">
                                        <h1>${project.title[lang]}</h1>
                                        <h2 class="has-text-grey">${project.users.join(' &bull; ')}</h2>
                                    </div>
                                </div>
                                <div class="content my-justify">
                                    ${project.abstract[lang]}
                                </div>
                            </div>
                            <footer class="card-footer">
                                <a href="${project.url[lang]}" target="_blank" class="card-footer-item" data-tippy-content="${tooltips.homepage}">
                                    <i class="fas fa-home fa-lg"></i>
                                </a>
                                <a href="${project.slides}" target="_blank" class="card-footer-item" data-tippy-content="${tooltips.download}" download>
                                    <i class="fas fa-download fa-lg"></i>
                                </a>
                                <a href="https://twitter.com/intent/tweet?text=View this video https://www.cognitiveinterfaces.de/symposium.html?project=${project.id}" target="_blank" class="card-footer-item" data-tippy-content="${tooltips.twitter}">
                                    <i class="fab fa-twitter fa-lg"></i>
                                </a>
                                <a href="mailto:?subject=${project.title[lang]}&amp;body=View this video https://www.cognitiveinterfaces.de/symposium.html?project=${project.id}" class="card-footer-item" data-tippy-content="${tooltips.email}">
                                    <i class="fas fa-envelope fa-lg"></i>
                                </a>
                            </footer>
                        </div>
                    </div>
                </div>
            `
        }

        html += projectsHtml
    }

    $('.projects').html(html)
    $('body').append(modals)
}
